<template>
    <table v-if="selectedComponent" class="table mt-2 border-bottom" style="margin-bottom: 0px;font-size: .85rem;">
        <tbody>

        <tr class="info-row">
            <td colspan="2" class="editor-content bg-primary text-white"><strong>Component - {{selectedComponent.type}}</strong></td>
        </tr>

        <context-color-editor :selected-component="selectedComponent" label="Color"></context-color-editor>

        <tr v-if="isCustomColor">
            <td class="editor-content editor-label">Custom color</td>
            <td class="editor-content">
                <color-picker :color-object="selectedComponent.style" color-field="color" class="mt-1" :shift-left="true"></color-picker>
            </td>
        </tr>

        <icon-size-editor :selected-component="selectedComponent"></icon-size-editor>

        <tr>
            <td class="editor-content editor-label">Icon</td>
            <td class="editor-content">
                <button class="btn btn-sm btn-success" @click="onEditIconClick">edit</button>
            </td>
        </tr>

        <view-link-properties v-if="view" :view="view" :selected-component="selectedComponent"></view-link-properties>

        <website-link-properties v-else :page="page" :selected-component="selectedComponent"></website-link-properties>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Border</td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Style</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select"
                        v-model="selectedComponent.border.type">
                    <option>none</option>
                    <option>solid</option>
                </select>
            </td>
        </tr>

        <context-color-editor :selected-component="selectedComponent" label="Border Color"></context-color-editor>

        <tr v-if="isCustomBorderColor">
            <td class="editor-content editor-label">Custom color</td>
            <td class="editor-content">
                <color-picker :color-object="selectedComponent.border" color-field="color" class="mt-1" :shift-left="true"></color-picker>
            </td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Border Radius</td>
            <td class="editor-content">
                <input class="form-control editor-form" type="number" v-model="selectedComponent.border.cornerRadius"/>
            </td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Width</td>
            <td class="editor-content">
                <input class="form-control editor-form" type="number" v-model="selectedComponent.border.width"/>
            </td>
        </tr>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Margin</td>
        </tr>

        <margin-selector :spacing="selectedComponent.margin"></margin-selector>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Padding</td>
        </tr>

        <margin-selector :spacing="selectedComponent.padding"></margin-selector>

        </tbody>
    </table>
</template>

<script>
    import ContextColorEditor from "./ContextColorEditor.vue";
    import IconSizeEditor from "./IconSizeEditor.vue";
    import ViewLinkProperties from "./ViewLinkProperties.vue";
    import WebsiteLinkProperties from "./WebsiteLinkProperties.vue";
    import MarginSelector from "./MarginSelector.vue";
    import ColorPicker from "../../components/ColorPicker.vue";
    export default {
        name: 'IconProperties',
        components: {
            ColorPicker,
            MarginSelector, WebsiteLinkProperties, ViewLinkProperties, IconSizeEditor, ContextColorEditor},
        props: ['layout', 'view', 'page', 'component'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            selectedComponent() {
                return this.component ? this.component : this.layout.selectedComponent
            },
            isCustomColor() {
                return this.selectedComponent.style && this.selectedComponent.style.color && (this.selectedComponent.style.color === 'custom' || this.selectedComponent.style.color.indexOf('#') === 0)
            },
            isCustomBorderColor() {
                return this.selectedComponent.border && this.selectedComponent.border.color && (this.selectedComponent.border.color === 'custom' || this.selectedComponent.border.color.indexOf('#') === 0)
            },
        },
        mounted () {
        },
        methods: {
            onEditIconClick() {
                webase.eventDispatcher.emit('editIconClick')
            }
        }
    }
</script>

